import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";

type Props = {
  setIsOpen: (isOpen: boolean) => void;
  onClose?: () => void;
  onSetErrorMessage?: (errorMessage: string) => void;
};

const useManageFailedConfirmationModal = ({
  setIsOpen,
  onClose,
  onSetErrorMessage,
}: Props) => {
  const { t } = useTranslation(TranslationContext.Checkout);

  const handleCloseModal = useCallback(() => {
    onSetErrorMessage && onSetErrorMessage("");
    setIsOpen(false);
    onClose && onClose();
  }, [onSetErrorMessage, setIsOpen, onClose]);

  return { handleCloseModal, t };
};

export default useManageFailedConfirmationModal;
